<shared-document-details [document]="document" [backLink]="backLink"></shared-document-details>
